import { render, staticRenderFns } from "./Concession.vue?vue&type=template&id=45b0322c&"
import script from "./Concession.vue?vue&type=script&lang=js&"
export * from "./Concession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports